module.exports = __webpack_public_path__ + "img/3.7615d7da.png";